// =============================================================================
// navigation.js | Author: Nexwork
// =============================================================================
$(() => {
    'use strict';

    // Mobile menu
    var $toggle = $('nav.school #menu-toggle');
    var $wrapper = $('.navbar--mobile');
    const mediaQuery = window.matchMedia('(min-width: 992px)')

    if ($toggle) {
        $toggle.click(function () {
            if ($toggle.hasClass('menu-expanded')) {
                $toggle.removeClass('menu-expanded');
                closeMobileMenu();
            }
            else {
                $toggle.addClass('menu-expanded');
                openMobileMenu();
            }
        });
    }

    if ($wrapper) {
        mediaQuery.addListener(showMainMenu)
        showMainMenu(mediaQuery)
    }

    // Search Toggle
    const searchOuter = document.querySelector('nav.school .utility-menu');
    const searchWrapper = searchOuter.querySelector('.nav-search-form-wrapper');
    const searchButton = searchOuter.querySelector('.search');

    if (searchButton) {
        searchButton.addEventListener('click', (e) => {
            e.stopPropagation();
            if (searchOuter) searchOuter.classList.add('search-visible');
            if (searchWrapper) {
                const searchWrapperInput = searchWrapper.querySelector('input');
                if (searchWrapperInput) searchWrapperInput.focus();
            }

            document.addEventListener('click', (e) => {
                if (searchOuter && !e.target.closest('.nav-search-form-wrapper')) {
                    searchOuter.classList.remove('search-visible');
                }
            }, { once: true });
        });
    }

    // Nav Items
    const navItems = document.querySelectorAll('.nav-item');
    const navItemsMobile = document.querySelectorAll('.nav-item--mobile');

    navItems.forEach(navItem => {
        const navSubmenu = navItem.querySelector('.submenu');
        const navItemToggle = navItem.querySelector('.nav-item-toggle');

        // Handle hover to show submenu
        navItem.addEventListener('mouseenter', () => {
            document.querySelectorAll('.submenu').forEach(submenu => submenu.classList.remove('visible'));
            if (navSubmenu) navSubmenu.classList.add('visible');
            if (navItemToggle) navItemToggle.classList.add('toggled');
        });

        // Handle mouse leave to hide submenu
        navItem.addEventListener('mouseleave', () => {
            if (navSubmenu) navSubmenu.classList.remove('visible');
            if (navItemToggle) navItemToggle.classList.remove('toggled');
        });

        // Toggle visibility on 'Enter' key press
        if (navItemToggle) {
            navItemToggle.addEventListener('keyup', (e) => {
                if (e.key === "Enter") {
                    if (navSubmenu) navSubmenu.classList.toggle('visible');
                    navItemToggle.classList.toggle('toggled');
                }
            });
        }

        // Hide all submenus on 'Tab' key press
        const navItemLabel = navItem.querySelector('.nav-item-wrapper .nav-item-link');
        navItemLabel.addEventListener('keyup', (e) => {
            if (e.key === "Tab") {
                document.querySelectorAll('.submenu').forEach(submenu => submenu.classList.remove('visible'));
                document.querySelectorAll('.nav-item-toggle').forEach(toggle => toggle.classList.remove('toggled'));
            }
        });

        const submenuToggle = navItem.querySelector('.submenu-toggle');

        if (submenuToggle) {
            submenuToggle.addEventListener('click', () => {
                navSubmenu.classList.remove('visible');
                navItemToggle.classList.toggle('toggled');
            });
        }
    });

    navItemsMobile.forEach(navItemMobile => {
        const navSubmenu = navItemMobile.querySelector('.submenu');
        const navItemToggle = navItemMobile.querySelector('.nav-item-toggle');

        //Toggle visibility on click
        if (navItemToggle) {
            navItemToggle.addEventListener('click', () => {
                if (navSubmenu) navSubmenu.classList.toggle('visible');
                navItemToggle.classList.toggle('toggled');
            });
        }
    });

    return;

    function closeMobileMenu() {
        if (!$wrapper) {
            return;
        }

        $wrapper.slideUp(150, () => {
            $wrapper.css('overflow', 'unset');
            $('body').css('overflow', 'unset');

            // Hide all submenus and reset toggles
            document.querySelectorAll('.submenu').forEach(submenu => submenu.classList.remove('visible'));
            document.querySelectorAll('.nav-item-toggle').forEach(item => item.classList.remove('toggled'));
        });
    }

    function openMobileMenu() {
        if (!$wrapper) {
            return;
        }

        $wrapper.slideDown(150, () => {
            $wrapper.css('overflow', 'hidden');
            $('body').css('overflow', 'hidden');
        });
    }

    function showMainMenu(e) {
        if (!e || !$wrapper) {
            return;
        }

        if (e.matches) {
            $wrapper.css("display", "block")
        } else {
            $wrapper.css("display", "none")
        }
    }
});

// Transparent Navbar Scroll Effect
document.addEventListener('scroll', () => {
    const navbarTransparent = document.querySelector('.navbar--transparent');
    if (navbarTransparent) {
        navbarTransparent.classList.toggle('scrolled', window.scrollY > 0);
    }
});
